<div [hidden]="!active" class="tab-pane">
    <ng-content></ng-content>
    <ng-container *ngIf="template"
      [ngTemplateOutlet]="template"
      [ngTemplateOutletContext]="dataContext"
    >
    </ng-container>
</div>